module.exports = __webpack_public_path__ + "static/media/notfound.b6902055.jpg";